import { Box, Button } from "@mui/material";
import React, { FunctionComponent } from "react";

import { Comment2AlertIcon, TrashIcon } from "assets";

import { Dialog } from "./dialog";

import { FLEX_CENTER_POSITIONING_STYLE } from "../consts";

export const DeleteDialog: FunctionComponent<{
  isOpen: boolean;
  onCancel: () => void;
  onDeleteClick: () => void;
  selectedCount?: number;
  target: any;
  title: string;
  confirmTitle?: string;
  confirmButtonDisabled?: boolean;
}> = ({ isOpen, onCancel, onDeleteClick, selectedCount, title, target, confirmTitle, confirmButtonDisabled }) => {
  const isPlural = selectedCount && selectedCount > 1;

  return (
    <Dialog
      title={title}
      isOpen={isOpen}
      onClose={onCancel}
      actions={
        <Box>
          <Button variant="outlined" color="warning" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            sx={{ ml: 2 }}
            variant="contained"
            color={target === "Approvals" ? "primary" : "error"}
            startIcon={target === "Approvals" ? "" : <TrashIcon />}
            onClick={onDeleteClick}
            disabled={confirmButtonDisabled}
          >
            <span>{confirmTitle ?? "Delete"}</span>
          </Button>
        </Box>
      }
    >
      <Box
        sx={{
          backgroundColor: "error.light",
          p: 2,
          borderRadius: 2,
          mb: 3,
          color: "error.main",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Box component="span" sx={{ ...FLEX_CENTER_POSITIONING_STYLE, mr: 1 }}>
          <Comment2AlertIcon />
        </Box>
        Warning! This action cannot be undone.
      </Box>
      {target === "Utility Provider Renewable Energy Rate" ? (<Box sx={{ maxWidth: "450px", marginLeft: "5px" }}>

        The {" "} {target} {isPlural && " "} supporting file will be deleted from the application. Are you sure you want to remove the file?
      </Box>) : (
        <Box>
          {target === "Parameter based Estimate" ? (
            <Box sx={{ maxWidth: "450px", marginLeft: "5px" }}>
              <b>Parameter based Estimate</b> will be permanently de-activated from
              the application. The data entries to this point will be kept but you
              will no longer be able to make changes to this estimate. Are you sure
              you want to de-activate this Parameter based Estimate?
            </Box>
          ) : target === "Data Provider" ? (
            <Box sx={{ maxWidth: "450px", marginLeft: "5px" }}>
              Are you sure you want to delete this data provider?
            </Box>
          ) : target === "Collector" || target === "Site" ? (
            <Box sx={{ maxWidth: "450px", marginLeft: "5px" }}>
              <b>{target === "Collector" ? "Utility provider" : "Site"}</b> will be
              de-activated and can no longer accept new data entries. All associated
              data and files in the platform will remain in the platform.
            </Box>
          ) : target === "Delete Collector" ? (
            <Box sx={{ maxWidth: "450px", marginLeft: "5px" }}>
              This Utility Provider will be permanently deleted from the application.
              Are you sure you want to delete the utility provider?
            </Box>
          ) : target === "Delete Purchase" ? (
            <Box sx={{ maxWidth: "450px", marginLeft: "5px" }}>
              Deleting this entry will delete all data associated with this REP.
            </Box>
          ) : target === "Delete Estimate" ? (
            <Box sx={{ maxWidth: "450px", marginLeft: "5px" }}>
              This Parameter Based Estimate will be permanently deleted from the
              application. Are you sure you want to delete this estimate?
            </Box>
          ) : target === "Approvals" ? (
            <Box sx={{ maxWidth: "450px", marginLeft: "5px" }}>
              By clicking confirm you will be undoing the approvals you selected.
            </Box>
          ) : target === "EmissionsAllocationDimensionColumn" ? (
            <Box sx={{ maxWidth: "450px", marginLeft: "5px" }}>
              Deleting this column will delete all data associated with it. Are you sure you want to delete the column?
            </Box>
          ) : target === "EmissionsAllocationSetup" ? (
            <Box sx={{ maxWidth: "450px", marginLeft: "5px" }}>
              Deleting this emissions allocation setup will delete all data associated with it. Are you sure you want to delete this?
            </Box>
          ) : target === "scorecardCellValue" ? (
            <Box sx={{ maxWidth: "450px", marginLeft: "5px" }}>
              All contents of this cell will be permanently deleted from the application. Any files and associated data entries linked to this cell will also be removed. Are you sure you want to delete these cell values?
            </Box>
          ) : target === "unreviewCell" ? (
            <Box sx={{ maxWidth: "450px", marginLeft: "5px" }}>
              The selected cell will no longer be marked as Reviewed. Are you sure you want to continue?
            </Box>
          ) : (
            <Box sx={{ maxWidth: "450px", marginLeft: "5px" }}>
              {selectedCount} {target}
              {isPlural && "s"} will be permanently deleted from the application.
              The file and all associated data entries will be deleted. Are you sure
              you want to delete {isPlural ? "these" : "this"} {target}{isPlural && "s"}?
            </Box>
          )}
        </Box>)}
    </Dialog>
  );
};
